import type { FaireReviewEntity } from "../../entity_types/review";

// Real product review, pulled from Sweet Wink's live Faire product page for
// the Glitter Heart Tutu Skirt (faire.com/product/p_f8wqg39g46), via the
// public, unauthenticated `GET /api/product-reviews/product/{product_token}`
// endpoint (the same one the PDP itself calls) — verbatim reviewer
// name/location/text/date, nothing paraphrased or invented.
export const review_sw6: FaireReviewEntity = {
  token: "review_sw6",
  type: "review",
  brandName: "Sweet Wink",
  brandToken: "b_gro99lye",
  productToken: "p_f8wqg39g46",
  productImageUrl:
    "https://cdn.faire.com/fastly/5838f702674e193f74c1c177f3a52a82d9bf1e906230724448a1feaed729ca0e.jpeg",
  reviewerName: "Megan R.",
  reviewerLocation: "Athens, PA, United States",
  stars: 5,
  reviewText:
    "We have been so pleased with Sweet Wink, their customer service, and the quality. I needed some items added to an order after it was placed and it was handled with ease. All of the items are of wonderful quality and our customers LOVE them! We will definitely be regulars from this point forward. Fantastic brand.",
  reviewDate: "Jan 27, 2023",
  reviewType: "product",
  meta: {
    source: "api",
    importedAt: "2026-08-12T07:15:00.000Z",
    importedBy: "entity-db-cli",
  },
};
